<template>
<div class="chapter">
<div class="inner_page">
<h2 id="sigil_toc_id_2">Contents</h2>
<p class="firstleft"><a href="#/Text/foreward">Foreword</a></p>
<blockquote>
<p class="first"><a href="#/Text/ch1#toc_marker-3">1 Facing Reality</a></p>
<p class="body"><a href="#/Text/ch1"><i>The Grace of Acceptance</i></a></p>
<p class="firstleft"><span href="#/Text/ch2#toc_marker-4" title="Link target outside of Sample">2 Experiencing the Presence</span></p>
<p class="body"><span href="#/Text/ch2" title="Link target outside of Sample"><i>The Grace of Submission</i></span></p>
<p class="firstleft"><span href="#/Text/ch3#toc_marker-5" title="Link target outside of Sample">3 Giving Up</span></p>
<p class="body"><span href="#/Text/ch3" title="Link target outside of Sample"><i>The Grace of Relinquishment</i></span></p>
<p class="firstleft"><span href="#/Text/ch4#toc_marker-6" title="Link target outside of Sample">4 Stuck in an Airport</span></p>
<p class="body"><span href="#/Text/ch4" title="Link target outside of Sample"><i>The Grace of Compassion</i></span></p>
<p class="firstleft"><span href="#/Text/ch5#toc_marker-7" title="Link target outside of Sample">5 God Is Not Mad at You</span></p>
<p class="body"><span href="#/Text/ch5" title="Link target outside of Sample"><i>The Grace of Trust</i></span></p>
<p class="firstleft"><span href="#/Text/ch6#toc_marker-8" title="Link target outside of Sample">6 Wounded Healers</span></p>
<p class="body"><span href="#/Text/ch6" title="Link target outside of Sample"><i>The Grace of Community</i></span></p>
<p class="firstleft"><span href="#/Text/ch7#toc_marker-9" title="Link target outside of Sample">7 A Cup of Cool Water</span></p>
<p class="body"><span href="#/Text/ch7" title="Link target outside of Sample"><i>The Grace of Comfort</i></span></p>
<p class="firstleft"><span href="#/Text/ch8#toc_marker-10" title="Link target outside of Sample">8 Life in the Slow Lane</span></p>
<p class="body"><span href="#/Text/ch8" title="Link target outside of Sample"><i>The Grace of Simplicity</i></span></p>
<p class="firstleft"><span href="#/Text/ch9#toc_marker-11" title="Link target outside of Sample">9 Possibilities</span></p>
<p class="body"><span href="#/Text/ch9" title="Link target outside of Sample"><i>The Grace of Hope</i></span></p>
<p class="firstleft"><span href="#/Text/ch10#toc_marker-12" title="Link target outside of Sample">10 Streams of Grace</span></p>
<p class="body"><span href="#/Text/ch10" title="Link target outside of Sample"><i>The Grace of Living a New Way</i></span></p>
</blockquote>
<p class="firstleft"><span href="#/Text/acknowledgments" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="firstleft"><span href="#/Text/notes#toc_marker-15" title="Link target outside of Sample">Notes</span></p>
<p class="firstleft"><span href="#/Text/praise#toc_marker-17" title="Link target outside of Sample">Praise for <i>The Way of Grace</i></span></p>
<p class="firstleft"><span href="#/Text/authors" title="Link target outside of Sample">About the Authors</span></p>
<p class="firstleft"><span href="#/Text/formatio" title="Link target outside of Sample">Formatio</span></p>
<p class="firstleft"><span href="#/Text/renovare" title="Link target outside of Sample">What is Renovaré?</span></p>
<p class="firstleft"><span href="#/Text/moreivp" title="Link target outside of Sample">More Titles from InterVarsity Press</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?b2acf616